// The admin portal's look: white cards on one light gray canvas.
export const adminColors = {
  canvas: '#f5f6f8',
  border: '#e6e8eb',
};

export const adminCard = {
  backgroundColor: '#fff',
  border: `1px solid ${adminColors.border}`,
  borderRadius: 8,
};

// Admin dialogs scroll their body so the footer buttons stay in view, and split the footer row on phones.
export const adminModal = (theme) => ({
  '& .ant-modal-body': {
    maxHeight: 'calc(100vh - 200px)',
    overflowY: 'auto',
  },
  [theme.breakpoints.down('sm')]: {
    '& .ant-modal-footer': {
      display: 'flex',
    },
    '& .ant-modal-footer .ant-btn': {
      flex: 1,
    },
  },
});

// The site nav and footer are fixed to the window, so sticky admin UI has to clear them.
export const SITE_NAV_HEIGHT = 71;
export const SITE_FOOTER_CLEARANCE = 72;
